#### Replay events by ID

We’ve extended the [`replayWebhookSubscription`] mutation with a new [`eventIds`] argument that can be used to replay events by their IDs.

```graphql
mutation (
  $webhookSubscription: ReplayWebhookSubscription_SubscriptionInput!
  $eventIds: [String!]
) {
  replayWebhookSubscription(
    input: { webhookSubscription: $webhookSubscription, eventIds: $eventIds }
  ) {
    webhookSubscription {
      id {
        value
      }
    }
  }
}
```

```json
{
  "webhookSubscription": {
    "id": "seekAnzPublicTest:webhookSubscription:events:BoJiJ9ZWFVgejLXLJxUnvL"
  },
  "eventIds": [
    "seekAnzPublicTest:event:events:ntLKio4NjhScF7TemEsWq",
    "seekAnzPublicTest:event:events:CexxKWfccy26wxbe4hDrjD"
  ]
}
```

This functionality has been packaged into the [Developer Dashboard webhooks page] where users can now select individual events to replay under the **Events** tab of each subscription.

[`replaywebhooksubscription`]: /schema/mutation/replayWebhookSubscription
[`eventids`]: /schema/named-type/ReplayWebhookSubscriptionInput#/field/eventIds
[Developer Dashboard webhooks page]: /manage/webhooks
